export default __webpack_public_path__ + "static/media/menu.fbd3aed9.svg";